<app-header />
<main class="app-shell__content">
  <router-outlet />
</main>
<app-footer />

<a
  class="support-fab"
  [href]="supportUrl"
  target="_blank"
  rel="noopener noreferrer"
  [attr.aria-label]="'support.label' | translate"
>
  <i class="pi pi-question-circle" aria-hidden="true"></i>
  <span>{{ 'support.label' | translate }}</span>
</a>
